import type { ApiClient } from '../../core/api-client.js';
import { ApiError } from '../../core/api-client.js';
import type { Resultado } from '../../core/resultado.js';
import type { RegistroAuditoria } from '@pgcustom/shared-types';

/** Adapter do módulo Auditoria no frontend — `GET /api/v1/auditoria` (Core, recurso `auth`, só `admin`). */
export class AuditoriaApi {
  constructor(private readonly api: ApiClient) {}

  async listarRecentes(limit = 100): Promise<Resultado<RegistroAuditoria[]>> {
    try {
      const resposta = await this.api.get<{ registros: RegistroAuditoria[] }>('/auditoria', { limit });
      if (resposta.registros.length === 0) return { status: 'vazio' };
      return { status: 'ok', dado: resposta.registros };
    } catch (erro) {
      if (erro instanceof ApiError && erro.status === 403) return { status: 'sem-permissao' };
      return { status: 'erro', mensagem: erro instanceof ApiError ? erro.message : 'falha ao carregar auditoria' };
    }
  }
}
